import { SvgIcon } from '@mui/material';
import React from 'react';
import { ReactComponent as Svg } from './discord.svg';

export const Discord = ()=>(
  <SvgIcon sx={{fillColor:'text.primary'}}><Svg/></SvgIcon>
)
